import { __rest as e } from "tslib";
import * as r from "react";
import a from "classnames";
import { classNameModifier as s, classNameModifierByFlag as t } from "../shared/utils.js";
import { ComponentClassNames as i } from "../shared/constants.js";
import { View as m } from "../View/View.js";
var n = {
    1: "h1",
    2: "h2",
    3: "h3",
    4: "h4",
    5: "h5",
    6: "h6"
  },
  o = r.forwardRef(function (o, c) {
    var l = o.className,
      d = o.children,
      h = o.isTruncated,
      _o$level = o.level,
      f = _o$level === void 0 ? 6 : _o$level,
      p = e(o, ["className", "children", "isTruncated", "level"]);
    return r.createElement(m, Object.assign({
      as: n[f],
      className: a(i.Heading, s(i.Heading, f), t(i.Heading, "truncated", h), l),
      ref: c
    }, p), d);
  });
o.displayName = "Heading";
export { o as Heading };